var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftQuote1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5118 43.9384C28.1638 43.2624 25.8158 42.9194 23.5318 42.9194C20.0048 42.9194 17.0618 43.7254 14.7798 44.7124C16.9798 36.6584 22.2648 22.7614 32.7928 21.1964C33.7678 21.0514 34.5668 20.3464 34.8328 19.3974L37.1338 11.1674C37.3278 10.4714 37.2128 9.72642 36.8158 9.12242C36.4188 8.51842 35.7808 8.11542 35.0658 8.01742C34.2888 7.91142 33.4968 7.85742 32.7118 7.85742C20.0748 7.85742 7.55978 21.0474 2.27878 39.9334C-0.82122 51.0134 -1.73022 67.6714 5.90578 78.1564C10.1788 84.0234 16.4128 87.1564 24.4348 87.4694C24.4678 87.4704 24.4998 87.4714 24.5328 87.4714C34.4308 87.4714 43.2078 80.8054 45.8778 71.2624C47.4728 65.5574 46.7518 59.5744 43.8458 54.4114C40.9708 49.3064 36.2358 45.5854 30.5118 43.9384Z",
    fill: "#E8EFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4708 54.4124C89.5958 49.3064 84.8608 45.5854 79.1368 43.9384C76.7888 43.2624 74.4408 42.9194 72.1578 42.9194C68.6308 42.9194 65.6868 43.7254 63.4048 44.7124C65.6048 36.6584 70.8898 22.7614 81.4188 21.1964C82.3938 21.0514 83.1918 20.3464 83.4588 19.3974L85.7598 11.1674C85.9538 10.4714 85.8388 9.72642 85.4418 9.12242C85.0458 8.51842 84.4078 8.11542 83.6918 8.01742C82.9158 7.91142 82.1238 7.85742 81.3378 7.85742C68.7008 7.85742 56.1858 21.0474 50.9038 39.9334C47.8048 51.0134 46.8958 67.6714 54.5328 78.1584C58.8048 84.0244 65.0398 87.1584 73.0608 87.4704C73.0938 87.4714 73.1258 87.4724 73.1598 87.4724C83.0568 87.4724 91.8348 80.8064 94.5048 71.2634C96.0978 65.5584 95.3758 59.5744 92.4708 54.4124Z",
    fill: "#E8EFFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.333,
    height: 95.332,
    fill: "white",
    transform: "translate(6.10352e-05 -0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftQuote1);
export default __webpack_public_path__ + "static/media/left-quote 1.f99e964df8f7357bc01ec71356aca349.svg";
export { ForwardRef as ReactComponent };